import { UserRound } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

const UPDATE_DETAILS_MAILTO =
  'mailto:info@claims1.co.uk?subject=Request%20to%20update%20my%20contact%20details'

const UpdateDetailsCta = () => {
  return (
    <Card className="border-foreground/15 rounded-2xl border bg-[#fff3ec]">
      <CardContent className="flex flex-col items-start gap-4 px-4 py-5 sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <div>
          <h2 className="text-foreground mb-1 flex items-center gap-2 text-lg font-bold sm:text-xl">
            <UserRound
              className="size-5 shrink-0 text-[#ff914d]"
              aria-hidden="true"
            />
            Changed your details?
          </h2>
          <p className="text-foreground/90 text-sm leading-relaxed sm:text-base">
            Let us know if your name, address, mobile number or email has
            changed.
          </p>
        </div>
        <Button
          asChild
          className="h-11 w-full bg-[#ff914d] font-bold text-[oklch(0.2205_0.0376_194.77)] hover:bg-[#ff914d]/90 sm:w-auto"
        >
          <a href={UPDATE_DETAILS_MAILTO}>Update your details</a>
        </Button>
      </CardContent>
    </Card>
  )
}

export default UpdateDetailsCta
